<!--
 * @Author: Shber
 * @Date: 2023-05-23 14:07:00
 * @LastEditors: Shber
 * @LastEditTime: 2023-05-31 14:48:55
 * @Description:
-->
<template>
  <div class="gc_weapp">
    <GCLOADING :is-show="loadingShow" />
    <GCHEADER ref="headRef" :is-show="!isMCbrowser" :des="pathDes" :webapp-link="routerLink" :param="query.id" />
    <div class="gc_theme">
      <div class="theme_banner" :style="{backgroundImage:'url('+ dataInfo.header_img_url +')'}">
        <div class="bottom_element">
          <div class="banner_text">
            <h2 class="text_overflow2"># {{ dataInfo.title }}</h2>
            <p>{{ dataInfo.join_num }} 人已参与</p>
            <p>{{ dataInfo.desc }}</p>
          </div>
          <div v-if="dataInfo.follow_status==0" class="follow_btn" @click="goPath(pathDes, query.id)">关注</div>
          <div v-else class="follow_btn_active" @click="goPath(pathDes, query.id)">已关注</div>
        </div>
      </div>
      <div class="tab_bar">
        <van-tabs v-model="tabActive" line-width="24px" line-height="2px" shrink @click-tab="tabChange">
          <van-tab title="最新" name="1" />
          <van-tab title="热门" name="2" />
        </van-tabs>
      </div>

      <van-list
        :loading="listLoading"
        :finished="finished"
        finished-text="没有更多了"
        @load="onLoadList"
      >
        <div class="work_info">
          <div class="work_list">
            <a v-for="(item, oddIndex) in state.dataList" :key="item.id" :href="webappLink+'/'+item.des+'?id='+item.id">
              <SingleFood
                v-if="oddIndex%2==0"
                class="list_item"
                :iszan="setZanShow(item)"
                :data-info="item"
                :no-height="true"
              />
            </a>
          </div>
          <div class="work_list right_list">
            <a v-for="(item, evenIndex) in state.dataList" :key="item.id" :href="webappLink+'/'+item.des+'?id='+item.id">
              <SingleFood
                v-if="evenIndex%2==1"
                :key="item.id"
                class="list_item"
                :iszan="setZanShow(item)"
                :data-info="item"
                :no-height="true"
              />
            </a>
          </div>
        </div>
      </van-list>
      <span class="icon_apply" @click="goPath(pathDes, query.id)" />
    </div>
    <ShareInfo :share-info="shareData" />
  </div>
</template>

<script setup>
import { ref, reactive } from 'vue'
import { useRouter } from 'vue-router'
import { Toast, List as vanList, Tab as vanTab, Tabs as vanTabs } from 'vant'
import { isGteatChefbrowser, superLink } from '@/utils/index'
import { get } from '@/api/ajax'
import config from '@/config/config'

import '@/style/scss/subjectview/index.scss'
import GCHEADER from '@/components/gc-header'
import GCLOADING from '@/components/gc-loading'
import ShareInfo from '@/components/shareInfo.vue'
import SingleFood from '@/components/singleFood.vue'

const router = useRouter()
const query = ref(router.currentRoute.value.query) // 页面id
const loadingShow = ref(true) // 页面loading锅盖
const listLoading = ref(false) // 列表下拉loading
const finished = ref(false) // 完成状态
const isMCbrowser = ref(isGteatChefbrowser()) // 名厨浏览器
const webappLink = ref(config.webapplink)
const routerLink = ref(location.href) // 页面路径
const tabActive = ref('1') // tab切换状态
const pathDes = ref(router.currentRoute.value.name) // 页面des
const headRef = ref(null)

const page = ref(1) // 页码
const noMore = ref(false) // 是否还有数据
let shareData = reactive({ share_title: '', share_desc: '', share_img: '', share_link: '' })

let dataInfo = reactive({
  title: '',
  muse_count: 0,
  food_count: 0,
  food: [],
  header_img_url: ''
}) // 页面数据
const state = reactive({
  dataList: [] // 页面列表数据
})

const setZanShow = ({ card_type, des }) => { // 判断是否展示赞
  return pathDes.value === 'subjectview' || ['1', '4', '5', '9'].includes(card_type) || (card_type === 2 && des === 'newsview')
}

const tabChange = (_tab) => {
  Toast.loading({
    message: 'Loading...',
    forbidClick: true
  })
  tabActive.value = _tab.name
  page.value = 1
  noMore.value = false
  finished.value = false
  state.dataList.length = 0
  getData()
}

const onLoadList = () => {
  Toast.loading({
    message: 'Loading...',
    forbidClick: true
  })
  getData()
}

const getData = async() => {
  const pathName = router.currentRoute.value.name
  let ajaxUrl = ''
  let data = {
    id: query.value.id,
    sort: tabActive.value,
    listrow: 20,
    page: page.value
  }
  if (pathName === 'subjectview') {
    ajaxUrl = '/subject/mini_program_detail'
    data = {
      sort: tabActive.value,
      is_card_type: 2,
      listrow: 20,
      page: page.value,
      subject_title: query.value.id // 我最难忘的童年味道
    }
  } else if (pathName === 'themeview') {
    ajaxUrl = '/api/theme/detail'
  } else {
    ajaxUrl = '/api/pag/detail'
  }

  if (noMore.value) {
    return Toast('暂无更多内容')
  }
  listLoading.value = true
  const res = await get(ajaxUrl, data)

  if (res.code === 1) {
    if (pathName === 'subjectview') {
      if (res.data.food.length === 0) {
        Toast('暂无更多内容')
        noMore.value = true
        finished.value = true
      } else {
        state.dataList = [...state.dataList, ...res.data.food]
      }
    } else {
      if (res.data.list.length === 0) {
        Toast('暂无更多内容')
        noMore.value = true
        finished.value = true
      } else {
        state.dataList = [...state.dataList, ...res.data.list]
      }
    }
    console.log('dataList', state.dataList)
    shareData = res.data.share
    dataInfo = res.data
  }
  listLoading.value = false
  loadingShow.value = false
  page.value += 1
  Toast.clear()
}
// getData()

const goPath = (_des, _skuid) => {
  const data = `{
          "des": "${_des}",
          "skuid": "${_skuid}",
          "link": "${config.webapplink}/${_des}?id=${_skuid}"
        }`
  return superLink(data, headRef.value)
}

</script>

<style lang="scss">
  .van-tabs {width: 30%;}
  .van-tab--active{font-weight: bold !important; color: #C99700 !important;}
</style>
